import React, { useMemo } from "react";

import { HubHookFormSelect } from "../HubHookFormSelect";
import { useShipmentListWithCache } from "./useShipmentListWithCache";

export const ShipmentHookFormSelect = ({
  name = "shipmentId",
  label = "Shipment",
  hideLabel = false,
  required = true,
  disabled = false,
  defaultValue,
  locationId = 1,
  ...rest
}) => {
  const { shipments, isLoading } = useShipmentListWithCache({ locationId });

  const list = useMemo(() => shipments || [], [shipments]);

  return (
    <HubHookFormSelect
      name={name}
      options={list}
      required={required}
      disabled={disabled || isLoading}
      defaultValue={defaultValue}
      MenuProps={{
        sx: {
          "& .MuiMenu-paper": {
            maxHeight: "400px",
          },
          "& .MuiMenu-list": {
            ".MuiPaper-root": {
              marginTop: "0 !important",
              boxShadow: "none !important",
              border: "0 !important",
              borderRadius: "0px !important",
            },
          },
        },
      }}
      {...(!hideLabel ? { label } : {})}
      {...rest}
    />
  );
};

export default ShipmentHookFormSelect;
